<template>
  <v-app id="app">
    <div v-if="!maintainer">
      <div>
        <!-- loader -->
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            width: 100vw;
            z-index: 1000;
            height: 100vh;
            position: fixed;
            background-color: #000000;
          "
          v-if="$store.state.gen.showLoader"
          :onload="this.getQuotes()"
        >
          <div class="loader">
            <div class="container">
              <div class="loader-icon">
                <img src="/static/img/loader/loading-viewZzz.svg" height="30" />
              </div>
              <div class="line"></div>
              <div class="loader-quote">
                <p class="quoteText">{{ currentQuote.text }}</p>
                <p class="quoteAuthor">{{ currentQuote.author }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- /loader -->
        <!-- praise mode modal -->
        <modal
          :clickToClose="false"
          :pivotY="0.65"
          width="309"
          height="auto"
          name="praise-mode-modal"
        >
          <div class="modal-main-container-praise">
            <!-- top -->
            <div class="div-1">
              <i class="material-icons">blur_circular</i>
            </div>
            <!-- /top -->

            <!-- middle -->
            <div class="div-2">
              <div class="div-2A">Welcome to the distraction</div>
              <div class="div-2A">free praise mode.</div>
              <div class="div-2A">No text & icons.</div>
            </div>
            <!-- middle -->

            <!-- bottom -->
            <div class="div-3">
              <div class="div-A">How to exit the praise mode?</div>
              <div class="div-B">
                <div class="text">1. Tap anywhere</div>
                <!--div
              class="icon-container"
            >
              <i class="material-icons ">add_circle</i>
                </div-->
              </div>
            </div>
            <!-- /bottom -->

            <!-- close -->
            <div class="div-4">
              <div
                @click="$modal.hide('praise-mode-modal')"
                class="div-4A pointer"
              >
                <div class="div-4AA">GOT IT!</div>
              </div>
            </div>
            <!-- close -->
          </div>
        </modal>
        <!-- /praise mode modal -->

        <div class="modal-main-container-loc-parent">
          <!-- ask to add to wishlist -->
          <modal
            :clickToClose="false"
            style="z-index: 900000000"
            width="309"
            height="auto"
            name="ask-to-add-to-wishlist"
          >
            <div class="modal-main-container-loc">
              <!-- top -->

              <div class="div-1">
                <div class="div-e1">
                  <!--      
              <div class="div-1A">
                <i class="material-icons">
                  favorite
                </i>
              </div>
              <div
                class="div-1B"
              >
                <i class="material-icons">
                  add
                </i>
              </div>
              <div
                class="div-1C"
              >
                <i class="material-icons">
                  near_me
                </i>
              </div>
                  -->
                </div>
              </div>

              <!-- /top -->

              <!-- middle -->
              <div class="div-2">
                <div class="div-2A">To find out exact location or</div>
                <div class="div-2A">driving directions of a view, it</div>
                <div class="div-2A">should be on your travel list.</div>
              </div>
              <!-- middle -->

              <!-- bottom -->
              <div class="div-3">
                <div class="div-3A">
                  <div @click="addToWishlish()" class="div-3AA pointer">
                    <div class="text">Add to travel list</div>
                    <div class="icon-container">
                      <i class="material-icons">add</i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /bottom -->

              <!-- close -->
              <div class="div-4">
                <div
                  @click="$modal.hide('ask-to-add-to-wishlist')"
                  class="div-4A pointer"
                >
                  <div class="div-4AA">GOT IT!</div>
                </div>
              </div>
              <!-- close -->
            </div>
          </modal>
          <!-- /ask to add to wishlist -->
        </div>

        <!-- license modal-->
        <modal
          style="z-index: 900000000"
          :pivotY="0.65"
          width="309"
          height="auto"
          name="license-modal"
        >
          <div class="modal-main-container">
            <!-- middle -->
            <div
              v-if="$store.state.imageDetails.license !== undefined"
              class="div-2"
            >
              <div class="div-2A text-xs-left">Copyright Information</div>
              <div class="div-2A light-blue--text">
                <span
                  class="pointer"
                  @click="
                    openInTab($store.state.imageDetails.license.licenseLink)
                  "
                  >{{ $store.state.imageDetails.license.type }}</span
                >
                /
                <span
                  class="pointer"
                  @click="
                    openInTab($store.state.imageDetails.license.photoSourceLink)
                  "
                  >Photo</span
                >
              </div>
            </div>
            <!-- middle -->

            <!-- close -->
            <div class="div-4">
              <div @click="$modal.hide('likes-modal')" class="div-4A pointer">
                <div class="div-4AA">
                  <div class="div-3" style="margin-top: unset">
                    <div class="div-3AA" style="font-size: 0.813em">
                      Report any copyright violations to contact@withaview.co
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- close -->
          </div>
        </modal>
        <!-- license modal-->

        <!-- location modal-->
        <modal
          :clickToClose="false"
          style="z-index: 900000000"
          :pivotY="0.82"
          width="309"
          height="158"
          name="location-modal"
        >
          <div class="praise-mode-modal">
            <!-- top -->
            <div class="top">
              <div class="text-loc" style="letter-spacing: 0.13em">
                Do you want to know how far is this view from you?
              </div>
            </div>
            <!-- /top -->

            <!-- bottom -->
            <div class="bottom">
              <div class="buttons">
                <div class="no" @click="$modal.hide('location-modal')">NO</div>
                <div
                  class="yes"
                  @click="
                    saveLocAllowedInLs();
                    getLocationFinal();
                  "
                >
                  YES
                </div>
              </div>
            </div>
            <!-- /bottom -->

            <!-- close -->
            <!--i
          @click="$modal.hide('location-modal')"
          class="material-icons close"
        >
          highlight_off
            </i-->
            <!-- close -->
          </div>
        </modal>
        <!-- /location modal -->

        <!-- OVERLAY - LOC -->
        <div
          @click="$store.state.common.showOverlay = false"
          v-if="showOverlay"
          id="overlay"
          :style="`display: ${showOverlay === true ? 'block' : 'none'}`"
        >
          <div style="position: relative">
            <img
              style="position: absolute; right: 2px; top: 10px; height: 100px"
              src="../static/img/overlay/ARROW.png"
            />
            <div
              style="
                color: #ffffff;
                font-weight: 400;
                font-family: Avenir, Helvetica, Arial, sans-serif;
                position: absolute;
                top: 90px;
                right: 110px;
                font-size: 14px;
                left: 10px;
              "
            >
              Location has been blocked from the browser, To turn on location,
              go to &#x2192; Settings &#x2192; Site settings/Content settings
              &#x2192; Location &#x2192; Blocked &#x2192;
              https://www.withaview.co &#x2192; Permissions &#x2192; Location
              access: Allow/Delete
            </div>
          </div>
          <!-- /OVERLAY - LOC -->

          <!-- close icon here -->
          <!--div
        style="display: flex; justify-content: center;
        position: absolute; bottom: 40px;
width: 100%;"
      >
        <i
          class="material-icons"
          style="color: #ffffff;"
        >
          clear
        </i>
          </div-->
          <!-- /close icon here -->
        </div>
        <!-- OVERLAY - LOC -->

        <!-- verify email -->
        <!--div v-if="isLoggedIn">
      <verifyEmail v-if="!user.emailVerified"></verifyEmail>
        </div-->

        <!-- once dbRef is cleared -->
        <!-- `forceRouteLoader` no longer req in condition now, we have nav guard. -->
        <!--fullscreenLoader v-if="dbRefLoader || authLoader"></fullscreenLoader-->
        <div v-if="dbRefLoader || authLoader"></div>
        <div v-else>
          <!-- hearder -->
          <!--customHeader></customHeader-->
          <main
            :class="`bottom-menu-class-${$store.state.common.isbottomMenuOpen}`"
          >
            <transition name="fade" mode="out-in" v-on:after-enter appear>
              <router-view></router-view>
            </transition>
          </main>
        </div>

        <div v-if="isbottomMenuOpen" class="bottom-menu" id="bottom-menu">
          <bottom-menu></bottom-menu>
        </div>

        <!-- alert -->
        <snackbar_alert></snackbar_alert>
        <!-- share bottom crumb -->
        <v-bottom-sheet v-model="$store.state.gen.sheet" style="z-index: 2000">
          <v-list>
            <v-subheader>Share via</v-subheader>
            <v-list-tile
              v-for="tile in tiles"
              :key="tile.title"
              @click="
                $store.state.gen.sheet = false;
                tile.func();
              "
            >
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <v-lazy-image :src="tile.img" :alt="tile.title" />
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-bottom-sheet>
        <!-- /share bottom crumb -->
      </div>
    </div>

    <!-- set maintainer(in data) to false to remove maintainance page -->
    <maintainer v-else />
  </v-app>
</template>

<script>
//
import platform from "platform";
import maintainer from "./components/maintainer";
//import {ele} from '@/helper/gen'
import "./assets/css/app.css";
import bottomMenu from "./components/common/bottomMenu";
//
import { mapGetters, mapMutations } from "vuex";
import fullscreenLoader from "@/components/loaders/fullscreenLoader";
import snackbar_alert from "@/components/alert/snackbar_alert";
import customHeader from "@/components/header/header";
import verifyEmail from "@/components/auth/verifyEmail";
import { ele } from "./helper/gen";
import imageLinks from "./mixin/imageLinks";
import configurations from "./configurations";
//
import { isFirstVisit, setFirstVisit } from "./helper/identifyFirstVisit";

let vm;
let cloudinarySettings = configurations.cloudinary_settings;
export default {
  mixins: [imageLinks],
  data() {
    return {
      maintainer: false,
      screenH: 0,
      screenW: 0,
      show_passcode_screen: true,
      test_password_input_type: "password",
      test_password: "",
      currentQuote: {
        author: "",
        text: "",
      },
      tiles: [
        {
          img: `/static/img/wav-what'sapp-icon.svg`,
          title: "Whatsapp",
          func: () => {
            window.open(
              `https://wa.me/?text=${configurations.currentDomain}/id/${vm.$store.state.gen.share_photoId}`
            );
          },
        },
        {
          img: `/static/img/wav-twitter-icon.svg`,
          title: "Twitter",
          func: () => {
            window.open(
              `http://twitter.com/share?text=Viewzzz&url=${configurations.currentDomain}/id/${vm.$store.state.gen.share_photoId}`
            );
          },
        },
        {
          img: `/static/img/wav-fb-icon.svg`,
          title: "Facebook",
          func: () => {
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${configurations.currentDomain}/id/${vm.$store.state.gen.share_photoId}`
            );
          },
        },

        /*{
            img: 'data:image/jpeg;base64,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',
            title: 'Instagram',
            func: () => {}
          },*/
        /*  { img: 'https://res.cloudinary.com/xviewzzzx/image/upload/h_100,${cloudinarySettings}/v1552240284/share/ut5nrnbmjgrxjdovnouk.png',
            title: 'Google +',
            func: ()=> {
              window.open(`https://plus.google.com/share?url=https://www.withaview.co/imageDetails/${vm.$store.state.gen.share_photoId}/${vm.$store.state.gen.share_caption}`)
            }
          }, */
        /* {
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStMxZyORDy5dHMCzchJCepiN1Ptmx1jK48Hf-4vg2fBb6Qb0wa',
            title: 'Pinterest',
            func: () => {
              window.open(`https://pinterest.com/pin/create/button/?url=https://wwww.withaview.co${vm.$router.currentRoute.fullPath}&media=Viewzzz&description=Share%20Beautiful%20Photos`)
            }
          } */
      ],
      quotes: [
        {
          author: "Lao Tzu",
          text: "A good traveler has no fixed plans, and is not intent on arriving.",
        },
        {
          author: "Michael Bassey Johnson",
          text: "A good traveler is one who knows how to travel with the mind.",
        },
        {
          author: "Tim Cahill",
          text: "A journey is best measured in friends rather than miles.",
        },
        {
          author: "John Steinbeck",
          text: "A journey is like marriage. The certain way to be wrong is to think you control it.",
        },
        {
          author: "Lao Tzu",
          text: "A journey of a thousand miles begins with a single step.",
        },
        {
          author: "John A. Shedd",
          text: "A ship in a harbor is safe, but it not what ships are built for.",
        },
        {
          author: "Aesop",
          text: "Adventure is worthwhile.",
        },
        {
          author: "Unknown",
          text: "Adventure may hurt you but monotony will kill you.",
        },
        {
          author: "Martin Buber",
          text: "All journeys have secret destinations of which the traveler is unaware.",
        },
        {
          author: "JRR Tolkien",
          text: "All that is gold does not glitter; just as not all those who wander are lost.",
        },
        {
          author: "Wolf, an Appalachian Trail Hiker",
          text: "All you need to know is that it’s possible.",
        },
        {
          author: "Unknown",
          text: "Better to see something once than hear about it a thousand times.",
        },
        {
          author: "Lovelle Drachman",
          text: "Blessed are the curious for they shall have adventures.",
        },
        {
          author: "Unknown",
          text: "Collect Moment, Not Things.",
        },
        {
          author: "Unknown",
          text: "Dare to live the life you’ve always wanted.",
        },
        {
          author: "Ralph Waldo Emerson",
          text: "Do not follow where the path may lead. Go instead where there is no path and leave a trail.",
        },
        {
          author: "Shane L. Koyczan",
          text: "Don’t let your luggage define your travels, each life unravels differently.",
        },
        {
          author: "Unknown",
          text: "Don’t listen to what they say. Go see.",
        },
        {
          author: "Mohammed",
          text: "Don’t tell me how educated you are, tell me how much you have traveled.",
        },
        {
          author: "Ma Jian",
          text: "Everything I was I carry with me, everything I will be lies waiting on the road ahead.",
        },
        {
          author: "Unknown",
          text: "Go, fly, roam, travel, voyage, explore, journey, discover, adventure.",
        },
        {
          author: "William Blake",
          text: "Great things are done when men and mountains meet.",
        },
        {
          author: "Mary Anne Radmacher",
          text: "I am not the same having seen the moon shine on the other side of the world.",
        },
        {
          author: "Paulo Coelho",
          text: "I can speak to my soul only when the two of us are off exploring deserts or cities or mountains or roads.",
        },
        {
          author: "Mark Twain",
          text: "I have found out that there ain’t no surer way to find out whether you like people or hate them than to travel with them.",
        },
        {
          author: "Susan Sontag",
          text: "I haven’t been everywhere, but it’s on my list.",
        },
        {
          author: "Derek Walcott",
          text: "I read; I travel; I become.",
        },
        {
          author: "Thomas Jefferson",
          text: "I think one travels more usefully when they travel alone because they reflect more.",
        },
        {
          author: "Caskie Stinnett",
          text: "I travel a lot; I hate having my life disrupted by routine.",
        },
        {
          author: "Carew Papritz",
          text: "I travel because it makes me realize how much I haven’t seen, how much I’m not going to see, and how much I still need to see.",
        },
        {
          author: "Roman Payne",
          text: "I wandered everywhere, through cities and countries wide. And everywhere I went, the world was on my side.",
        },
        {
          author: "A. Redmerski",
          text: "I wonder if the ocean smells different on the other side of the world.",
        },
        {
          author: "John Green",
          text: "I’m in love with cities I’ve never been to and people I’ve never met.",
        },
        {
          author: "Santosh Kalwar",
          text: "If life is a journey then let my soul travel and share your pain.",
        },
        {
          author: "James Michener",
          text: "If you reject the food, ignore the customs, fear the religion and avoid the people, you might better stay at home.",
        },
        {
          author: "Paul Coelho",
          text: "If you think adventures are dangerous, try routine: It’s Lethal.",
        },
        {
          author: "Unknown",
          text: "In the end, we only regret the chances we didn’t take.",
        },
        {
          author: "Unknown",
          text: "It feels good to be lost in the right direction.",
        },
        {
          author: "Ursula K. Le Guin",
          text: "It is good to have an end to journey toward, but it is the journey that matters in the end.",
        },
        {
          author: "Henry David Thoreau",
          text: "It’s not what you look at that matters. It’s what you see.",
        },
        {
          author: "Helen Keller",
          text: "Life is either a daring adventure or nothing at all.",
        },
        {
          author: "Unknown",
          text: "Life is short and the world is wide.",
        },
        {
          author: "Benjamin Disraeli",
          text: "Like all great travelers, I have seen more than I remember, and remember more than I have seen.",
        },
        {
          author: "Oscar Wilde",
          text: "Live life with no excuses, travel with no regret.",
        },
        {
          author: "Stephen Covey",
          text: "Live your life by a compass not a clock.",
        },
        {
          author: "Tennessee Williams",
          text: "Make voyages. Attempt them. There’s nothing else.",
        },
        {
          author: "Andre Gide",
          text: "Man cannot discover new oceans unless he has the courage to lose sight of the shore.",
        },
        {
          author: "Jodi Picoult",
          text: "Maybe you had to leave in order to miss a place; maybe you had to travel to figure out how beloved your starting point was.",
        },
        {
          author: "Roman Payne",
          text: "Never did the world make a queen of a girl who hides in houses and dreams without traveling.",
        },
        {
          author: "Amin Maalouf",
          text: "Never hesitate to go far away, beyond all seas, all frontiers, all countries, all beliefs.",
        },
        {
          author: "Banana Yoshimoto",
          text: "No matter where you are, you’re always a bit on your own, always an outsider.",
        },
        {
          author: "Lin Yutang",
          text: "No one realizes how beautiful it is to travel until he comes home and rests his head on his old, familiar pillow.",
        },
        {
          author: "J.R.R. Tolkien",
          text: "Not all those who wander are lost.",
        },
        {
          author: "Unknown",
          text: "Oh Darling, Let’s Be Adventurers.",
        },
        {
          author: "Dr. Seuss",
          text: "Oh the places you’ll go.",
        },
        {
          author: "Dalai Lama",
          text: "Once a year, go someplace you’ve never been before.",
        },
        {
          author: "Michael Palin",
          text: "Once the travel bug bites there is no known antidote, and I know that I shall be happily infected until the end of my life.",
        },
        {
          author: "Henry Miller",
          text: "One’s destination is never a place, but a new way of seeing things.",
        },
        {
          author: "John Steinbeck",
          text: "People don’t take trips, trips take people.",
        },
        {
          author: "Unknown",
          text: "Quit your job, buy a ticket, get a tan, fall in love, never return.",
        },
        {
          author: "Roy M. Goodman",
          text: "Remember that happiness is a way of travel – not a destination.",
        },
        {
          author: "Jack Kerouac",
          text: "So shut up, live, travel, adventure, bless and don’t be sorry.",
        },
        {
          author: "Erol Ozan",
          text: "Some beautiful paths can’t be discovered without getting lost.",
        },
        {
          author: "Chief Seattle",
          text: "Take only memories, leave only footprints.",
        },
        {
          author: "Agnes Repplier",
          text: "The impulse to travel is one of the hopeful symptoms of life.",
        },
        {
          author: "Dan Eldon",
          text: "The journey is the destination.",
        },
        {
          author: "T.S. Eliot",
          text: "The journey not the arrival matters.",
        },
        {
          author: "Anna Quindlen",
          text: "The life you have led doesn’t need to be the only life you have.",
        },
        {
          author: "Henry David Thoreau",
          text: "The man who goes alone can start today, but he who travels with another must wait till that other is ready.",
        },
        {
          author: "Wallace Stevens",
          text: "The most beautiful in the world is, of course, the world itself.",
        },
        {
          author: "G.K. Chesterton",
          text: "The traveler sees what he sees. The tourist sees what he has come to see.",
        },
        {
          author: "Augustine of Hippo",
          text: "The world is a book and those who do not travel read only one page.",
        },
        {
          author: "Ralph Waldo Emerson",
          text: "The world makes way for the man who knows where he is going.",
        },
        {
          author: "Robert Louis Stevenson",
          text: "There are no foreign lands. It is the traveler only who is foreign.",
        },
        {
          author: "Paulo Coelho",
          text: "This wasn’t a strange place; it was a new one.",
        },
        {
          author: "Ralph Waldo Emerson",
          text: "Though we travel the world over to find the beautiful, we must carry it with us, or we find it not.",
        },
        {
          author: "Freya Stark",
          text: "To awaken quite alone in a strange town is one of the pleasantest sensations in the world.",
        },
        {
          author: "Aldous Huxley",
          text: "To travel is to discover that everyone is wrong about other countries.",
        },
        {
          author: "Hans Christian Andersen",
          text: "To travel is to live.",
        },
        {
          author: "Elizabeth Gilbert",
          text: "To travel is worth any cost or sacrifice.",
        },
        {
          author: "Alex Garland",
          text: "Tourists went on holidays while travelers did something else. They traveled.",
        },
        {
          author: "Jalaluddin Rumi",
          text: "Travel brings power and love back into your life.",
        },
        {
          author: "Joe Abercrombie",
          text: "Travel brings wisdom only to the wise. It renders the ignorant more ignorant than ever.",
        },
        {
          author: "Marty Rubin",
          text: "Travel doesn’t become adventure until you leave yourself behind.",
        },
        {
          author: "Claire Fontaine",
          text: "Travel empties out everything you’ve into the box called your life, all the things you accumulate to tell you who you are.",
        },
        {
          author: "David Mitchell",
          text: "Travel far enough, you meet yourself.",
        },
        {
          author: "Mark Twain",
          text: "Travel is fatal to prejudice, bigotry, and narrow-mindedness.",
        },
        {
          author: "Miriam Beard",
          text: "Travel is more than the seeing of sights; it is a change that goes on, deep and permanent, in the ideas of living.",
        },
        {
          author: "Unknown",
          text: "Travel is the only thing you buy that makes you richer.",
        },
        {
          author: "Thomas Fuller",
          text: "Travel makes a wise man better, and a fool worse.",
        },
        {
          author: "Gustave Flaubert",
          text: "Travel makes one modest. You see what a tiny place you occupy in the world",
        },
        {
          author: "Ibn Battuta",
          text: "Traveling – it leaves you speechless, then turns you into a storyteller.",
        },
        {
          author: "Gayle Foreman",
          text: "Traveling’s not something you’re good at. It’s something you do. Like Breathing.",
        },
        {
          author: "Robert Frost",
          text: "Two roads diverged in a wood and I – I took the one less traveled by, and that has made all the difference.",
        },
        {
          author: "Ray Bradbury",
          text: "We travel for romance, we travel for architecture, and we travel to be lost.",
        },
        {
          author: "Anonymous",
          text: "We travel not to escape life, but for life not to escape us.",
        },
        {
          author: "Anais Nin",
          text: "We travel, some of us forever, to seek other states, other lives, other souls.",
        },
        {
          author: "Hilaire Belloc",
          text: "We wander for distraction but we travel for fulfillment.",
        },
        {
          author: "Jack Kerouac",
          text: "We wandered in a frenzy and a dream.",
        },
        {
          author: "Clifton Fadiman",
          text: "When you travel, remember that a foreign country is not designed to make you comfortable. It is designed to make its own people comfortable.",
        },
        {
          author: "Vera Nazarian",
          text: "Whenever you go on a trip to visit foreign lands or distant places, remember that they are all someone’s home and backyard.",
        },
        {
          author: "Anita Desai",
          text: "Wherever you go becomes a part of you somehow.",
        },
        {
          author: "Neil Gaiman",
          text: "Wherever you go, you take yourself with you.",
        },
        {
          author: "Frank Herbert",
          text: "Without new experiences, something inside of us sleeps. The sleeper must awaken.",
        },
        {
          author: "Unknown",
          text: "Work, Travel, Save, Repeat.",
        },
        {
          author: "Kirsten Hubbard",
          text: "You can’t control the past, but you can control where you go next.",
        },
        {
          author: "George Bernard Shaw",
          text: "I dislike feeling at home when I am abroad.",
        },
        {
          author: "Henry David Thoreau",
          text: "Not until we are lost do we begin to understand ourselves.",
        },
        {
          author: "Mohamed",
          text: "Don’t tell me how educated you are, tell me how much you travelled.",
        },
        {
          author: "Kurt Vonnegut",
          text: "Bizarre travel plans are dancing lessons from God.",
        },
        {
          author: "Martin Buber",
          text: "All journeys have secret destinations of which the traveller is unaware.",
        },
        {
          author: "Paul Theroux",
          text: "Tourists don’t know where they’ve been, travellers don’t know where they’re going.",
        },
        {
          author: "Robert Louis Stevenson",
          text: "There are no foreign lands. It is the traveller only who is foreign.",
        },
        {
          author: "Albert Einstein",
          text: "I love to travel, but hate to arrive.",
        },
        {
          author: "Hilaire Belloc",
          text: "We wander for distraction, but we travel for fulfillment.",
        },
        {
          author: "Benjamin Disraeli",
          text: "Travel teaches toleration.",
        },
        {
          author: "Ray Bradbury",
          text: "Half of the fun of travel is the aesthetic of lostness.",
        },
        {
          author: "Ben Francia",
          text: "Great things never came from comfort zones.",
        },
        {
          author: "Maya Angelou",
          text: "If you are always trying to be normal, you will never know how amazing you can be.",
        },
        {
          author: "Unknown",
          text: "Fear is only temporary. Regrets last forever.",
        },
        {
          author: "Neale Donald Walsch",
          text: "Life begins at the end of your comfort zone.",
        },
        {
          author: "David McCullough Jr.",
          text: "Climb the mountain so you can see the world, not so the world can see you.",
        },
        {
          author: "Alexander Sattler",
          text: "I would rather own a little and see the world than own the world and see a little of it.",
        },
        {
          author: "William Langewiesche",
          text: "So much of who we are is where we have been.",
        },
        {
          author: "Paulo Coelho",
          text: "Travel is never a matter of money but of courage.",
        },
        {
          author: "Shakespeare",
          text: "The earth has music for those who listen.",
        },
        {
          author: "Unknown",
          text: "Do more things that make you forget to check your phone.",
        },
        {
          author: "Carew Papritz",
          text: "I travel because I become uncomfortable being too comfortable.",
        },
        {
          author: "Peter McWilliams",
          text: "Nothing adventured, nothing attained.",
        },
        {
          author: "Seth Godin",
          text: "If it scares you, it might be a good thing to try.",
        },
        {
          author: "Franklin D. Roosevelt",
          text: "Above all, try something.",
        },
        {
          author: "Unknown",
          text: "Good things come to those who book flights.",
        },
        {
          author: "Edith Wharton",
          text: "One of the great things about travel is that you find out how many good, kind people there are.",
        },
        {
          author: "Unknown",
          text: "If you look like your passport photo, you probably need the trip.",
        },
        {
          author: "Rachel Wolchin",
          text: "If we were meant to stay in one place, we’d have roots instead of feet.",
        },
        {
          author: "Unknown",
          text: "My favourite thing is to go where I’ve never been.",
        },
        {
          author: "Unknown",
          text: "It’s bad manners to keep an adventure waiting.",
        },
        {
          author: "Ray Bradbury",
          text: "We travel for romance, we travel for architecture, we travel to be lost.",
        },
        {
          author: "Ernest Hemingway",
          text: "Never go on trips with anyone you do not love.",
        },
        {
          author: "Unknown",
          text: "Some things weren’t meant to be tamed. For example, YOU.",
        },
        {
          author: "Ben Franklin",
          text: "Either write something worth reading or do something worth writing.",
        },
        {
          author: "John Steinbeck",
          text: "I wonder how many people I’ve looked at all my life and never seen.",
        },
        {
          author: "Unknown",
          text: "May you never be too busy to stop and breathe under a palm tree.",
        },
        {
          author: "Unknown",
          text: "Don’t quit your daydream.",
        },
        {
          author: "Ernest Hemingway",
          text: "The best way to find out if you can trust somebody is to trust them.",
        },
        {
          author: "Winston Churchill",
          text: "I like things to happen. And if they don’t happen, I like to make them happen.",
        },
        {
          author: "Unknown",
          text: "Surround yourself with people who get it.",
        },
        {
          author: "Terry Pratchett",
          text: "Coming back to where you started is not the same as not leaving.",
        },
        {
          author: "Paul Theroux",
          text: "Travel is glamorous only in retrospect.",
        },
        {
          author: "Aerin Lauder",
          text: "To understand what’s going on in the world, you have to see the world.",
        },
        {
          author: "Ugo Eze",
          text: "Be careful who you make memories with. Those things can last a lifetime.",
        },
        {
          author: "Walt Whitman",
          text: "Not I, not anyone else, can travel that road for you. You must travel it for yourself.",
        },
        {
          author: "Shanti",
          text: "At the end of the day, your feet should be dirty, your hair should be messy and your eyes sparkling.",
        },
        {
          author: "Your Passport",
          text: "You’ll never know until you go.",
        },
        {
          author: "Unknown",
          text: "Travelling is about finding those things that you never knew you were looking for.",
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["getLocationFinal", "addToWishlish"]),
    openInTab(link) {
      console.log(link);
      window.open(link, "_blank");
    },
    getQuotes() {
      let x = Math.floor(Math.random() * this.quotes.length);
      this.currentQuote = this.quotes[x];
    },
    saveLocAllowedInLs() {
      localStorage.setItem("isLocationEnabled", "y");
    },
    verify_test_password(password) {
      let passwords = [`qwezxc`, `viewz5`];
      if (passwords.includes(password)) {
        console.log(`Good to go.`);
        localStorage.setItem("_p", "_");
        this.show_passcode_screen = false;
      } else {
        console.log(`wrong passcode :/ `);
        this.$store.commit("snackbar_alert", {
          msg: `Incorrect Passcode !`,
        });
      }
    },
  },
  //
  computed: {
    ...mapGetters([
      "showOverlay",
      "dbRefLoader",
      "user",
      "isLoggedIn",
      "authLoader",
      "forceRouteLoader",
      "isbottomMenuOpen",
      "opencw",
    ]),
  },
  //
  components: {
    maintainer,
    fullscreenLoader,
    snackbar_alert,
    customHeader,
    verifyEmail,
    bottomMenu,
  },
  //
  updated() {
    /*this.$store.dispatch('getLoginStatus').then((isLoggedIn)=>{
        // once auth is resolved, call this auth dependent function
        console.log("[isLoggedIn] => ", isLoggedIn)
        //
        /* this.$store.commit('forceRoute', {
          routeName: this.$route.name
        })*/
    // })
  },
  created() {
    vm = this;
    //
    /* setTimeout (()=>{
        this.$modal.show('ask-to-add-to-wishlist')
      },5000) */
    window.thisOfApp = this;
    if (localStorage.getItem("_isFirstVisit") != null && screen.width < 600) {
      this.showOnboardings = false;
    } else {
      this.showOnboardings = false;
    }
    // i am send test call to apis here !
    // testing: 1st query custom list.
    /* this.$store.commit('getCustomList', {
        customList: 'testberlin',
        isFirstQuery: true,
        limit: 2,
        startAt: 0
      }) */
    //
    let _isFirstVisit = isFirstVisit();
    this.$store.state.gen._isFirstVisit = _isFirstVisit;
    //
    setFirstVisit();
    //
    //
    // check passcode
    let _isPasscodeEntered = localStorage.getItem("_p");
    if (_isPasscodeEntered === null) {
      // show enter passcode screen
      this.show_passcode_screen = false; //true
    } else {
      // hideenter passcode screen
      this.show_passcode_screen = false;
    }
    // /check passcode
  },
  mounted() {
    this.screenW = screen.width;
    this.screenH = screen.height;
    setTimeout(() => {
      //console.log('isUpdateAvailable?=>',localStorage.getItem("isUpdateAvailable"))
      let version = localStorage.getItem("isUpdateAvailable");
      //
      if (version == "YES") {
        this.$store.commit("snackbar_alert", {
          msg: "New version available!!! Please RELOAD for best experience.",
        });
      } else {
        // nothing
      }
      //
    }, 6000);
    //
  },
  watch: {
    "$store.state.common.swichModesBG": () => {
      let ele = document.getElementsByClassName("container-switch-modes")[0];
      console.log("MODE ELE", ele);
      if (!vm.$store.state.common.swichModesBG) {
        TweenMax.to(ele, 1, { top: `-50vh` });
      } else {
        TweenMax.to(ele, 1, { top: `3.5em` });
      }
    },
    show_passcode_screen: {
      handler() {
        //alert(this.show_passcode_screen)
        if (this.show_passcode_screen === false) {
          //alert(this.show_passcode_screen)
          setTimeout(() => {
            if (this.$router.currentRoute.query.loc === `Elsewhere`) {
              setTimeout(() => {
                this.$store.state.gen.showLoader = false;
              }, 5);
              //alert(`920`)
              vm.$store.commit(`getElsewherePics`, {
                limit: this.$store.state.hello.limit,
                startAt: 0,
              });
            } else if (this.$router.currentRoute.query.loc === "Berlin") {
              setTimeout(() => {
                this.$store.state.gen.showLoader = false;
              }, 5);
              // Berlin
              //alert(`932`)
              this.$store.commit(`getMainScreenImages`, {
                query: JSON.stringify({ testamp: ["testberlin"] }),
                startAt: 0,
                limit: this.$store.state.hello.limit,
                uid: this.$store.state.auth.user.uid,
                isLoggedIn: this.$store.state.auth.isLoggedIn,
              });
            }
            //
          }, 10);
        }
      },
    },
    "$store.state.gen.opencw": () => {
      if (!vm.$store.state.gen.opencw) {
        console.log(`closing dialog, distroy upload widget`);
        //
        document.getElementById("inline_container").innerHTML = "";
        //
      }
    },
  },
};
</script>
<style lang="scss">
body {
  overflow-y: hidden;
}
i {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  //display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8); /* Black background with opacity */
  z-index: 1000000000; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
// i{
//   cursor: pointer;
// }
.quoteText {
  font-family: "MontSerrat-Regular";
  font-size: 18px;
  color: #ffffff;
}

.quoteAuthor {
  font-family: "MontSerrat-Regular";
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
.upload-page-1-container {
  .v-chip,
  .application .theme--light.v-chip {
    background: white !important;
    color: rgba(0, 0, 0, 0.87);
    border: 1px solid #2196f3;
  }
}
main {
  margin-top: 0 !important;
}
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.carausel-container {
  .btn--icon .btn__content {
    padding: 0;
    visibility: hidden;
  }
  img {
    height: 100vh;
    object-fit: cover;
  }
  .v-jumbotron__wrapper {
    height: 100vh;
    position: relative;
    transition: inherit;
    width: 100%;
    object-fit: cover;
    overflow-x: scroll;
    overflow-y: hidden;
  }
}
.bottom-menu {
  position: fixed;
  z-index: 100011;
  right: 0;
  bottom: 0;
  color: white;
  opacity: 0;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

@font-face {
  font-family: "MontSerrat";
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: local("MontSerrat"),
    url("../src/assets/fonts/Montserrat-Bold.otf") format("truetype");
}

@font-face {
  font-family: "MontSerrat-Light";
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: local("MontSerrat-Light"),
    url("../src/assets/fonts/MontserratAlternates-Light.otf") format("truetype");
}
@font-face {
  font-family: "MontSerrat-Regular";
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: local("MontSerrat-Regular"),
    url("../src/assets/fonts/Montserrat-Regular.ttf") format("truetype");
}

.bottom-menu-class-true {
  position: fixed;
  height: 100vh;
  width: 100vw;
  filter: blur(10px);
  transform: scale(1.1);
}

.v-snack__content {
  height: auto !important;
}

.v--modal {
  border-radius: 15px !important;
}

.modal-main-container-loc-parent {
  .v--modal {
    @media (max-height: 568px) {
      top: 160px !important;
    }
    @media (min-height: 569px) and (max-height: 640px) {
      top: 220px !important;
    }
    @media (min-height: 641px) and (max-height: 667px) {
      top: 220px !important;
    }
    @media (min-height: 668px) and (max-height: 736px) {
      top: 250px !important;
    }
    @media (min-height: 737px) and (max-height: 1024px) {
      top: 400px !important;
    }
    @media (min-height: 1025px) {
      top: 500px !important;
    }
  }
}

.v--modal-overlay .v--modal-background-click {
  min-height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.v-responsive__content{
 display: flex;
 align-items: center;
 justify-content: center; 
}

.praise-mode-modal {
  color: black;
  padding: 20px;
  position: relative;
  width: 100%;
  height: 100%;

  .top {
    display: flex;

    i {
      font-size: 50px;
    }

    .text {
      // padding-left: 14px;
      font-family: "Montserrat-Bold", sans-serif;
      // font-family: 'Roboto Slab', serif;
      padding-left: 14px;
      font-size: 12px;
      text-align: left;
      font-weight: 600;
      letter-spacing: 2px;
    }

    .text-loc {
      font-family: "Montserrat-Bold", sans-serif;
      font-size: 14px;
      text-align: left;
      letter-spacing: 2px;
      font-weight: 700 !important;
    }
  }

  .bottom {
    padding-top: 15px;
    display: flex;
    //font-weight: 600;
    font-family: "MontSerrat-Regular", sans-serif;
    // font-family: 'Roboto Slab', serif;
    font-size: 12px;
    text-align: left;
    letter-spacing: 2px;

    .buttons {
      display: flex;
      width: 100%;
      justify-content: center;

      @mixin button($bg) {
        height: 43px;
        width: 127px;
        background-color: $bg;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "Avenir", serif;
        color: white;
        font-weight: 900 !important;
        margin: 0 2px;
      }

      .no {
        @include button(rgb(74, 74, 74));
      }

      .yes {
        @include button(rgb(189, 16, 224));
      }
    }

    i {
      position: relative;
      top: 1.82px;
      color: rgb(80, 227, 194);
      font-size: 14px;
    }

    .fav {
      color: rgb(74, 144, 226) !important;
      text-shadow: 2px 2px 2px #666666;
    }

    .text {
      font-size: 12px;
      letter-spacing: 2.5px;
      font-family: "MontSerrat-Regular", sans-serif;
      vertical-align: middle;
      height: 100%;
      padding: 0 15px;
    }
  }

  .close {
    color: rgb(74, 74, 74);
    position: absolute;
    right: 3px;
    bottom: 3px;
    font-size: 25px;
  }
}
.loader {
  height: 280px;
  width: 550px;
  padding: 10px;
  font-family: "MontSerrat", sans-serif;
  font-weight: normal;
  transform: translate(25%);
  .container {
    display: flex;
    height: 100%;
    width: 100%;
    .loader-icon {
      height: 100%;
      display: flex;
      align-items: center;
      padding-right: 25px;
    }
    .loader-quote {
      color: white;
      display: flex;
      justify-content: center;
      height: 100%;
      flex-direction: column;
      text-align: left;
      padding-left: 25px;
    }
    .line {
      height: 100%;
      width: 2px;
      background-color: white;
      height: 100%;
    }
  }
  @media only screen and (max-width: 768px) {
    height: auto;
    max-width: 280px;
    transform: translate(0);
    .container {
      flex-wrap: wrap;
      height: auto;
      .loader-icon {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        padding-right: 0px;
        padding-bottom: 25px;
        justify-content: center;
      }
      .loader-quote {
        height: auto;
        width: 100%;
        flex-direction: column;
        text-align: center;
        padding-left: 0px;
        padding-top: 15px;
      }
      .line {
        height: 2px;
        width: 100%;
        background-color: white;
      }
    }
  }
}

.v-text-field.v-text-field--enclosed .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding: 0 !important;
}

.v-dialog__content {
  //  z-index: 1000000001 !important;
}

.profile-container-new {
  .v-dialog__content {
    //  z-index: 0 !important;
  }
}
select {
  font-size: 16px;
}
input[type="color"],
input[type="date"],
input[type="datetime"],
input[type="datetime-local"],
input[type="email"],
input[type="month"],
input[type="number"],
input[type="password"],
input[type="search"],
input[type="tel"],
input[type="text"],
input[type="time"],
input[type="url"],
input[type="week"],
select:focus,
textarea {
  font-size: 18px;
}

@import "../src/assets/scss/overlays.scss";
@import "../src/assets/scss/overlay_checkin.scss";
@import "../src/assets/scss/overlay_praise.scss";
@import "../src/assets/scss/overlays_ask_to_add_to_wishlist.scss";

.container {
  padding: 0 !important;
}

.application--wrap {
  flex: 1 1 auto;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}
.upload-page-1-container {
  .v--modal {
    margin-top: -5px;
    background-color: white;
    padding: 10px;
  }

  .mapModal {
    .v--modal {
      margin-top: -5px;
      background-color: #000000;
      color: #ffffff;
      padding: 10px;
      border: 0.2px solid #ffffff;
    }
    .map-input-box {
      background-color: #000000;
      color: #ffffff;
      font-family: Montserrat;
    }
    .map-input-box::placeholder {
      color: #ffffff;
    }
  }

  .main-container {
    .v--modal {
      border-radius: 0 !important;
      background-color: white;
    }
  }
}
.v-switch-core {
  transform: scale(0.7);
  padding: 0 0.3em;
  border: 2px solid black;
  .v-switch-button {
    width: 10px !important;
    height: 10px !important;
    top: 0.1em !important;
    border: 2px solid black;
    background-color: transparent !important;
  }
}
.circular-loader {
  margin: 20px -3px 20px 0;
  svg {
    background: black;
    border-radius: 50%;
  }

  .v-progress-circular__info {
    font-size: 12px;
    font-weight: 600;
  }
}
.pointer {
  cursor: pointer;
}
.int-pm {
  .int-pm-btn {
    background-color: transparent !important;
    border: none !important;
  }
  .disabled {
    background-color: transparent !important;
  }
  .int-pm-value {
    border: none !important;
    flex-grow: 1 !important;
    font-family: "MontSerrat-Regular";
    color: #b9b9b9;
    font-weight: 100;
    p {
      margin-bottom: 5px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?4bbcf67c